import type { FlotiqInStoreDeliveryStore } from "@jti/fe-common/types";

import { isLocation } from "../isLocation";

export const isFlotiqStoreData = (flotiqStoreData: unknown): flotiqStoreData is FlotiqInStoreDeliveryStore => {
  return (
    typeof flotiqStoreData === "object" &&
    flotiqStoreData !== null &&
    "id" in flotiqStoreData &&
    "Status" in flotiqStoreData &&
    "StoreName" in flotiqStoreData &&
    "ZipCode" in flotiqStoreData &&
    "Street" in flotiqStoreData &&
    "Country" in flotiqStoreData &&
    "ExternalId" in flotiqStoreData &&
    "Location" in flotiqStoreData &&
    typeof flotiqStoreData.id === "string" &&
    typeof flotiqStoreData.Status === "boolean" &&
    typeof flotiqStoreData.StoreName === "string" &&
    typeof flotiqStoreData.ZipCode === "string" &&
    typeof flotiqStoreData.Street === "string" &&
    typeof flotiqStoreData.Country === "string" &&
    typeof flotiqStoreData.ExternalId === "string" &&
    isLocation(flotiqStoreData.Location)
  );
};
